import {
  API_AUTH,
  API_AUTHNEW,
  setTokenForNewAPI,
  setTokenGlobal,
} from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";
import { getUserLogin } from "utils/utils";
import { getDomainNew } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}

var urlAPINew = getDomainNew();
var tokenNew = cookies.get("userTokenDaiLy");
if (typeof tokenNew != "undefined" && tokenNew.length > 6) {
  token = tokenNew.substring(6);
  setTokenForNewAPI(token, urlAPINew);
}

const DanhSachNguoiDungApi = {

  chitietnguoidungdaily: (userName) => {
    return API_AUTH.get(`users/GetFullUserDaiLyByUserName?sUserName=${userName}`, {});
  },

  capnhatmatkhaudaily: (username, matkhaucu, matkhau, nhaplaimatkhau) => {
    return API_AUTH.post(`user/doimatkhau_nguoidungdaily?username=${username}&matkhaucu=${matkhaucu}&matkhau=${matkhau}&nhaplaimatkhau=${nhaplaimatkhau}`, {});
  },
  // -----------------------------------------------------------------------




  list: ({ branchId, sSearch, hoatdong, userlogin, pageIndex, pageSize }) =>
    API_AUTH.get(
      `hethong/danhsach_nguoidung?branchId=${branchId}&sSearch=${sSearch}&hoatdong=${hoatdong}&userlogin=${userlogin}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  addAndEditNguoiDung: (
    userId,
    userName,
    passWord,
    rePassword,
    fullName,
    email,
    phone,
    chinhanhId,
    nhomquyenId,
    userlogin
  ) => {
    return API_AUTH.post(
      `hethong/add_update_nguoidung?userId=${userId}&userName=${userName}&passWord=${passWord}&rePassword=${rePassword}&fullName=${fullName}&email=${email}&phone=${phone}&chinhanhId=${chinhanhId}&nhomquyenId=${nhomquyenId}&userlogin=${userlogin}`,
      {}
    );
  },
  chiTietNguoiDung: (userId) => {
    return API_AUTH.post(`hethong/chitiet_nguoidung?userId=${userId}`, {});
  },
  listNhomQuyen: () => {
    return API_AUTH.get(`hethong/combo_nhomquyen`, {});
  },
  listChiNhanh: (userlogin) => {
    return API_AUTH.get(`hethong/combo_chinhanh?userlogin=${userlogin}`, {});
  },
  xoaNguoiDung: (userName) => {
    return API_AUTH.post(`hethong/xoa_nguoidung?userName=${userName}`, {});
  },
  doiMatKhauNguoiDung: (userId, matkhau, nhaplaimatkhau) => {
    return API_AUTH.post(
      `hethong/doimatkhau_nguoidung?userId=${userId}&matkhau=${matkhau}&nhaplaimatkhau=${nhaplaimatkhau}`,
      {}
    );
  },
  khoaNguoiDung: (userName) => {
    return API_AUTH.post(`hethong/khoa_nguoidung?userName=${userName}`, {});
  },
  moKhoaNguoiDung: (userName) => {
    return API_AUTH.post(`hethong/mokhoa_nguoidung?userName=${userName}`, {});
  },



};

export default DanhSachNguoiDungApi;
